import { render, staticRenderFns } from "./AttachedToPositionsCounterButton.vue?vue&type=template&id=43452806&scoped=true"
import script from "./AttachedToPositionsCounterButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachedToPositionsCounterButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AttachedToPositionsCounterButton.vue?vue&type=style&index=0&id=43452806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43452806",
  null
  
)

export default component.exports